var $zoho= $zoho || {};
$zoho.salesiq = $zoho.salesiq || {
    widgetcode: "siq4cc4909b7e3f171b9bf22a55ccc5343cf2a347afba13bb568b8ab78f56902059",
    values:{},
    ready:function(){}
};
function loadSalesIq() {
    console.log('Creating Zoho SalesIQ script')
    const d = document;
    let s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "https://salesiq.zohopublic.com/widget";
    d.body.appendChild(s);
}